// Petits utilitaires purs partagés (rotation de cellules, bbox, échappement HTML).
export const rotFns: Record<string, (c: number[]) => number[]> = {
  x: c => [c[0], -c[2], c[1]],
  y: c => [c[2], c[1], -c[0]],
  z: c => [-c[1], c[0], c[2]],
};

// Centre de la boîte englobante d'un ensemble de cellules.
export function bboxCenter(cs: number[][]): number[] {
  let a = 1e9, b = 1e9, c2 = 1e9, d = -1e9, e = -1e9, f = -1e9;
  for (let i = 0; i < cs.length; i++) {
    const c = cs[i];
    if (c[0] < a) a = c[0]; if (c[0] > d) d = c[0];
    if (c[1] < b) b = c[1]; if (c[1] > e) e = c[1];
    if (c[2] < c2) c2 = c[2]; if (c[2] > f) f = c[2];
  }
  return [(a + d) / 2, (b + e) / 2, (c2 + f) / 2];
}

export function escapeHtml(s: unknown): string {
  return ('' + s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c] as string));
}
